module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-05 at 2.10.14 PM.14e85c71.jpeg";